export default __webpack_public_path__ + "static/media/iPadSS10.6a428304.png";